
import { Injectable } from '@angular/core';
import { CotacaoRamoService } from './cotacao-ramo.service';
import { IntegracaoConstants } from 'src/app/constants/integracao';
import { UtilsService } from '../utils.service';
import { CalcsResults } from 'src/app/models/calculos/calcs-results.model';
import { CalcAuto } from 'src/app/models/calcAuto.model';
import { RecalculoService } from 'recalculo';
import { ApiUsuarioService } from '../api-usuario.service';
import { LeadsConstants } from 'src/app/constants/leads';
import { ApiSeguradoraService } from '../api-seguradora.service';
import { ApiInterfaceService } from '../api/api-interface.service';

@Injectable({
  providedIn: 'root'
})

export class CotacaoAutoService implements CotacaoRamoService {

  public _leadsCadastrados = LeadsConstants.leads;
  public wakUser;

  public _seguradorasBase = IntegracaoConstants.seguradoras;
  private _franquias = IntegracaoConstants.tipoFranquiaTxt;
  private _coberturasMulti = IntegracaoConstants.tipoCoberturaMultiTxt;
  private _sexo = IntegracaoConstants.sexoTxt;
  private _profissoes = IntegracaoConstants.profissoesTxt;
  private _estadoCivil = IntegracaoConstants.estadoCivilTxt;
  private _tpUso = IntegracaoConstants.tpUsoTxt;
  private _carroReserva = IntegracaoConstants.carroReservaTxt;
  private _assist24hs = IntegracaoConstants.assist24hsTxt;
  private _stepsId = IntegracaoConstants.stepsId;
  private _ramos = IntegracaoConstants.ramos;
  private _packageType = IntegracaoConstants.packageType;

  private tipoReq = 5;

  public dadosUser: any = []

  constructor(
    private utilsService: UtilsService,
    private apiUsuario: ApiUsuarioService,
    public recalculoService: RecalculoService,
  ) {
  }

  sessoesPDF() {
    return [{
      code: 1,
      description: "Segurado/Automóvel",
      selected: true
    },
    {
      code: 2,
      description: "Condutor Principal",
      selected: true
    },
    {
      code: 3,
      description: "Coberturas",
      selected: true
    },
    {
      code: 4,
      description: "Cálculos com erro",
      selected: true
    }]
  }

  setComissaoDefault(su) {
    return su;
  }

  async getCoberturasUser(api) {
    return api.getCoberturasAutoUser();
  }

  setCoberturas(v, arrObj) {

    if (v.calculos && v.calculos.length)
      arrObj.forEach(obj => {
        let cob = v.calculos[0];
        let ret = {};
        for (let cc in obj) {
          ret[cc] = cob[cc];
        }
      });
    return arrObj;
  }

  getMessageCalcExtension(subramo?) {
    return 'VER_CALCULO';
  }

  getColumnsGridCalculosVersao() {
    return ['seguradora', 'premio', 'franquia', 'comissao', 'cobertura', 'danosMateriais', 'danosCorporais', 'danosMorais', 'tempo'];
  }

  getCfgDefault(idSeg) {
    return {
      ID: -1,
      assist24hs: 2,
      ativo: true,
      carroReserva: 3,
      descricao: "Normal",
      despesasExtra: false,
      farolRetrovis: true,
      idIntegracaoCfg: 48621,
      idIntegracaoCfgSeg: 48621,
      isAcessorios: 0,
      isAppInvalidez: 20000,
      isAppMorte: 20000,
      isDanosCorporais: 100000,
      isDanosMateriais: 100000,
      isDanosMorais: 10000,
      libertyCodigoEstabelacimento: 1,
      libertyDescontoRegional: 1,
      login: "NAO_CONFIGURADO",
      nome: "Azul",
      nomeSeguradora: "Azul",
      percComissao: 10,
      percComissao2: 10,
      percComissao3: 10,
      percDesconto: 0,
      percDesconto2: 0,
      percDesconto3: 0,
      portoSusep: "F6256J",
      seguradora: 10,
      senha: "NAO_CONFIGURADO",
      tipoCobertura: 4,
      tipoFranquia: 1,
      vidros: true,
    };
  }

  getCalcObject(draft, seguradoras, coberturas) {
    let obj = JSON.parse(JSON.stringify(draft));
    let propertiesToDelete = ['configuracoes'];
    propertiesToDelete.map(function (pd) {
      delete obj[pd];
    });

    obj.ramo = this._ramos.AUTO;
    obj.tipo = 5;

    let hoje = new Date();
    let vigIni = new Date(obj.vigenciaIni);
    let limiteRetroativo: any = new Date();
    limiteRetroativo = this.utilsService.editarData({ data: limiteRetroativo, operacao: "-", dia: 15, mes: 0, ano: 0 });

    if (limiteRetroativo)
      if (limiteRetroativo.getTime() > vigIni.getTime()) {
        obj.vigenciaIni = hoje.toISOString();
        hoje.setFullYear(hoje.getFullYear() + 1);
        obj.vigenciaFim = hoje.toISOString();
      }


    for (let prop in obj) {
      if (obj === null)
        delete obj[prop];
    }

    obj.calculos = seguradoras.habilitadas.filter(function (cfg) { return cfg.ativo });
    obj.calculos = obj.calculos.map(el => {
      let objCalc = { ...el, ...coberturas };
      delete objCalc['pctAjuste'];
      objCalc.percComissao = el.percCom ? parseInt(el.percCom) : 0;
      objCalc.percDesconto = el.percDesc ? parseInt(el.percDesc) : 0;

      this.utilsService.clearCfgSegToCalc(objCalc);

      if (!objCalc.libertyCodigoEstabelecimento)
        objCalc.libertyCodigoEstabelecimento = null;
      if (!objCalc.libertyDescontoRegional)
        objCalc.libertyDescontoRegional = 1;

      if (objCalc.seguradora == this._seguradorasBase.PORTO_SEGURO.id) {
        let seghab = seguradoras.habilitadas.find(cfg => { return cfg.seguradora == this._seguradorasBase.AZUL.id });

        if (seghab) {
          objCalc.percComissao3 = seghab.percCom ? parseInt(seghab.percCom) : 0;
          objCalc.percDesconto3 = seghab.percDesc ? parseInt(seghab.percDesc) : 0;
        }
      }

      if (objCalc.seguradora == this._seguradorasBase.AZUL.id && obj.renovacao && obj.seguradoraAnteriorId == '535') {
        if (objCalc.azulCfg) {
          // objCalc.ID = objCalc.azulCfg.ID;
          objCalc.idIntegracao = objCalc.azulCfg.idIntegracao;
          objCalc.idIntegracaoCfg = objCalc.azulCfg.ID;
          objCalc.idIntegracaoCfgSeg = objCalc.azulCfg.ID;
          objCalc.senha = objCalc.azulCfg.senha;
          objCalc.usuario = objCalc.azulCfg.usuario;
          objCalc.login = objCalc.azulCfg.usuario;
        } else {
          // objCalc.ID = -1;
          objCalc.idIntegracaoCfg = -1;
          objCalc.idIntegracaoCfgSeg = -1;
          objCalc.senha = "NAO_CONFIGURADO";
          objCalc.usuario = "NAO_CONFIGURADO";
          objCalc.login = "NAO_CONFIGURADO";
        }
      }

      delete objCalc.azulCfg;
      delete objCalc.ID;

      return objCalc;

    });

    obj.automoveis[0].pctAjuste = coberturas.pctAjuste;
    obj.automoveis[0].placa = obj.automoveis[0].placa ? obj.automoveis[0].placa.toUpperCase() : obj.automoveis[0].placa;

    return obj;

  }

  coberturasMerge(coberturas, obj) {
    if (obj.automoveis) {
      coberturas.forEach(function (cfe) {
        cfe.pctAjuste = obj.automoveis[0].pctAjuste;
      });
    }
  }

  getSeguradorasStatus(seguradorasUser, servicesInfos, cfg, estadoSegurado) {
    let segStatusKey;
    switch (cfg.tipo) {
      case 'm': segStatusKey = 'moto'; break;
      case 'c': segStatusKey = 'truck'; break;
      case 'v':
      default:
        segStatusKey = 'car';
    }

    let segStatus = JSON.parse(JSON.stringify(servicesInfos.calculos.auto[segStatusKey]));

    for (let idx in segStatus) {

      let options = segStatus[idx];

      let reduced = options.reduce((filtered, option) => {

        if (seguradorasUser) {
          let seg = seguradorasUser.find((cfgUser) => { return option.id == cfgUser.seguradora });

          if (seg && seg.seguradora != this._seguradorasBase.AZUL.id && seg.seguradora != this._seguradorasBase.ALIRO.id && seg.seguradora != this._seguradorasBase.MITSUI.id) {

            seg.idIntegracaoCfg = seg.ID;
            seg.idIntegracaoCfgSeg = seg.ID;

            seg.login = seg.usuario;

            seg.percCom = seg.percComissao;
            seg.percDesc = seg.percDesconto;

            let cfgSegConfig = { ...option, ...seg };

            filtered.push(cfgSegConfig);

            if (cfgSegConfig.seguradora == this._seguradorasBase.PORTO_SEGURO.id) {
              let copySeg = this.copyCfgSeg(cfgSegConfig, "AZUL");
              let azulCfg = seguradorasUser.find((cfgUser) => { return this._seguradorasBase.AZUL.id == cfgUser.seguradora });
              copySeg.azulCfg = azulCfg;
              copySeg.percCom = azulCfg?.percComissao ? azulCfg.percComissao : 0;
              copySeg.percDesc = azulCfg?.percDesconto ? azulCfg.percDesconto : 0;
              filtered.push(copySeg);

              let copySegMitsui = this.copyCfgSeg(cfgSegConfig, "MITSUI");
              let mitsuiCfg = seguradorasUser.find((cfgUser) => { return this._seguradorasBase.MITSUI.id == cfgUser.seguradora });
              copySegMitsui.percCom = mitsuiCfg?.percComissao ? mitsuiCfg.percComissao : copySegMitsui.percComissao;
              copySegMitsui.percDesc = mitsuiCfg?.percDesconto ? mitsuiCfg.percDesconto : 0;
              copySegMitsui.mitsuiCfg = mitsuiCfg
              filtered.push(copySegMitsui);
            } else if (cfgSegConfig.seguradora == this._seguradorasBase.LIBERTY_SITE.id) {
              let copySeg = this.copyCfgSeg(cfgSegConfig, "ALIRO");
              copySeg.percCom = 0;
              copySeg.percDesc = 0;
              filtered.push(copySeg);
            }

            if (cfgSegConfig.seguradora == this._seguradorasBase.PORTO_SEGURO.id) {
              let copySeg = this.copyCfgSeg(cfgSegConfig, "ITAU");
              copySeg.percCom = copySeg.percCom ? copySeg.percCom : 0;
              copySeg.percDesc = copySeg.percDesconto3 ? copySeg.percDesconto3 : 0;
              let itauCfg = seguradorasUser.find((cfgUser) => { return this._seguradorasBase.ITAU.id == cfgUser.seguradora });
              copySeg.itauCfg = itauCfg;
              filtered.push(copySeg);
            }
          }
        }

        return filtered;

      }, []);

      segStatus[idx] = reduced;
      segStatus[idx].sort(function (a, b) {
        if (a.nome > b.nome) {
          return 1;
        }
        if (a.nome < b.nome) {
          return -1;
        }
        return 0;
      });

    }

    return segStatus;
  }

  matStepRoute(action, selectedStep, flags) {
    switch (selectedStep) {
      case this._stepsId.formulario:
        if (action == "next") {
          return "enviarCalculo";
        } else if (action == "previous") {
          return "resultados";
        }
        break;

      case this._stepsId.coberturas:
        if (action == "next") {
          return "calcular";
        } else if (action == "previous") {
          return "enviarCalculo"
        } else if(action == "ajuste"){
          return "ajustePorSeguradora";
        }
        break;
      case this._stepsId.simuladorComissoes:
        if (action == "next") {
          return "simToEnviarCalculo";
        } else if (action == "previous") {
          return "resultados";
        }
        break;
      case this._stepsId.enviarCalculo:
        if (action == "next") {
          return "coberturas";
        } else if (action == "previous") {
          if (flags.simuladorComissoes) {
            return "simuladorComissoes";
          } else if (flags.calcular) {
            return "resultados";
          } else {
            return "formulario"
          }
        }
        break;
      case this._stepsId.ajustePorSeguradora:
        if (action == "next") {
          return "calcular";
        } else if (action == "previous") {
          return "coberturas";
        }
        break;
    }
  }

  //adaptado para o apice
  createDraft(negocio, opt?) {

    if (!negocio) {
      negocio = new CalcAuto();
      negocio.isClearDraft = true;
    }
    negocio.tipo = this.tipoReq;
    if (opt) {
      if (opt.seguradoUrl) {
        let propertiesToCopy = [
          "nome",
          "tipoPessoa",
          "cpfCnpj",
          "estadoCivil",
          "dataNasc",
          "sexo",
          "fone1",
          "fone",
          "email",
          "cep",
          "residLogradouro",
          "residNumero",
          "residCidade",
          "residBairro",
          "complemento",
          "residUF"
        ];
        propertiesToCopy.forEach((p) => {
          negocio.segurado[p] = opt.seguradoUrl[p];
        });
        negocio.segurado.seguradoUrl = true;
      }
      if (opt.negocioUrl) {
        negocio.negocioId = opt.negocioUrl;
      }
    }

    this.copyToRoot(negocio);
    return negocio;
  }

  createVersions(arrayVersions) {

    return arrayVersions.map((v) => {

      //Se não tiver versão, é calculo antigo, e respectivamente é a primeira versão, ou
      //Versão é igual a 0 e foi somente salvo, sem calcular, não deveria acessar a tela de resultado, somente o formulario.

      // debugger;
      // console.log( v.versao);

      // if (!v.versao && v.versao !== 0)
      //   v.versao = 1;

      if (Number.isInteger(arrayVersions[0].ID) && arrayVersions[0].versao === 0) {
        v.versao = v.versao + 1;
        arrayVersions[0].versaoWak = true;
      } else if (arrayVersions[0].versaoWak) {
        v.versao = v.versao + 1;
      }

      //console.log( v.versao);

      this.copyToRoot(v);
      this.addVersion(v);

      this.utilsService.setResultsAll(v);
      this.utilsService.sortResults(v);

      return v;

    });

  }

  private copyCfgSeg(obj, newSeg) {
    let copySeg = JSON.parse(JSON.stringify(obj));

    copySeg.seguradora = this._seguradorasBase[newSeg].id;
    copySeg.id = this._seguradorasBase[newSeg].id;

    copySeg.nomeSeguradora = this._seguradorasBase[newSeg].name;
    copySeg.nome = this._seguradorasBase[newSeg].name;

    copySeg.logo = this.utilsService.getPathLogoById(this._seguradorasBase[newSeg].id);

    return copySeg;

  }

  private copyToRoot(v) {
    if (v.calculos && v.calculos.length) {
      v.tpFranquiaTxt = this._franquias[v.calculos[0].tipoFranquia];
      v.tpCoberturaCalcTxt = this._coberturasMulti[v.calculos[0].tipoCobertura];

      v.calculos.forEach(vc => {
        if (!vc.idIntegracaoCfgSeg)
          vc.idIntegracaoCfgSeg = vc.idIntegracaoCfg;
      });

    }

    if (v.automoveis) {
      //debugger;
      v.automoveis[0].fipeTxt = this.utilsService.formatFipe(v.automoveis[0].fipe);
    }
  }

  private addVersion(v) {

    v.vigenciaIniTxt = this.utilsService.dateStringToTxt(v.vigenciaIni);
    v.vigenciaFimTxt = this.utilsService.dateStringToTxt(v.vigenciaFim);

    v.numeroRenovacaoTxt = v.numeroRenovacao ? v.numeroRenovacao : "Não informada";

    v.segurado.cpfCnpjTxt = this.utilsService.cpfCnpj(v.segurado.cpfCnpj);
    v.segurado.dataNascTxt = this.utilsService.dateStringToTxt(v.segurado.dataNasc);
    v.segurado.sexoTxt = this._sexo[v.segurado.sexo];
    v.segurado.profissaoTxt = this._profissoes[v.segurado.profissao];
    v.segurado.estadoCivilTxt = this._estadoCivil[v.segurado.estadoCivil];

    v.segurado.cepTxt = this.utilsService.formatCep(v.segurado.cep);

    v.results = new CalcsResults();

    if (v.automoveis[0].condutores && v.automoveis[0].condutores.length) {
      v.automoveis[0].condutores[0].cpfCnpjTxt = v.automoveis[0].condutores[0]?.cpfCnp ? this.utilsService.cpfCnpj(v.automoveis[0].condutores[0].cpfCnpj) : null;
      v.automoveis[0].condutores[0].dataNascTxt = this.utilsService.dateStringToTxt(v.automoveis[0].condutores[0].dataNasc);
      v.automoveis[0].condutores[0].sexoTxt = this._sexo[v.automoveis[0].condutores[0].sexo];
      v.automoveis[0].condutores[0].profissaoTxt = this._profissoes[v.automoveis[0].condutores[0].profissao];
      v.automoveis[0].condutores[0].estadoCivilTxt = this._estadoCivil[v.automoveis[0].condutores[0].estadoCivil];
      v.automoveis[0].condutores[0].cepTxt = this.utilsService.formatCep(v.automoveis[0].condutores[0].cep);
      v.automoveis[0].cepCirculacaoTxt = this.utilsService.formatCep(v.automoveis[0].cepCirculacao);
      v.automoveis[0].placa = v.automoveis[0].placa ? v.automoveis[0].placa.toUpperCase() : v.automoveis[0].placa;
      v.automoveis[0].cepPernoiteTxt = this.utilsService.formatCep(v.automoveis[0].cepPernoite);
      v.automoveis[0].jovemCondutorTxt = v.automoveis[0].jovemCondutor ? "Sim" : "Não";
      v.automoveis[0].idaVoltaTrabalhoCompletoTxt = "Não";
      v.automoveis[0].idaVoltaEstudoCompletoTxt = "Não";
      v.automoveis[0].tpUsoTxt = this._tpUso[v.automoveis[0].tpUso];

      if (v.automoveis[0].idaVoltaTrabalho) {
        if (v.automoveis[0].garTrabManha || v.automoveis[0].garTrabNoite || v.automoveis[0].garTrabTarde) {
          v.automoveis[0].idaVoltaTrabalhoCompletoTxt = "Sim, com garagem"
        } else {
          v.automoveis[0].idaVoltaTrabalhoCompletoTxt = "Sim, sem garagem"
        }
      }

      if (v.automoveis[0].idaVoltaEstudo) {
        if (v.automoveis[0].garEstudoManha || v.automoveis[0].garEstudoNoite || v.automoveis[0].garEstudoTarde) {
          v.automoveis[0].idaVoltaEstudoCompletoTxt = "Sim, com garagem"
        } else {
          v.automoveis[0].idaVoltaEstudoCompletoTxt = "Sim, sem garagem"
        }
      }

    }

    if (v.calculos && v.calculos.length) {
      v.calculos[0].assist24hsTxt = this._assist24hs[v.calculos[0].assist24hs];
      v.calculos[0].carroReservaTxt = this._carroReserva[v.calculos[0].carroReserva];
      v.calculos[0].tipoFranquiaTxt = this._franquias[v.calculos[0].tipoFranquia];
    }

    this.updateResults(v);

  }

  adicionarLeads(v){
    var leads = this._leadsCadastrados;
    var storage:any = localStorage.getItem('nao-exibir-leads' )

    if (typeof storage == 'string')
       storage = JSON.parse(storage)

    storage = Array.isArray(storage) ? storage  : []

    leads = leads.filter(item =>{
       var temConfig = this.dadosUser.find(c => c.seguradora == item.seguradoraId)

       let temCalcuSeg = v.calculos.find(c => c.seguradora == item.seguradoraId)

       if (temConfig.ativo || temCalcuSeg)
          return false

       let seg = storage.find(s => s.seg == item.seguradoraId )

       return seg ? false : true
    })

    leads.forEach(l =>{
      if (l.ramos.vida)
          v.results.main["successes"].push(l)
    })
  }

  public updateResults(versao) {
    versao.calculos.forEach((vr) => {
      vr.veiculo = versao.automoveis[0].descricao;
      //debugger;
      vr.fipe = versao.automoveis[0].fipeTxt;
      this.extractResultsAuto(versao, vr);
    });

    this.utilsService.setResultsAll(versao);
    this.utilsService.sortResults(versao);
    this.adicionarLeads(versao)
  }

  async setDadosUser(){

    try{
        let dt = await this.apiUsuario.getListCfgsSegs()

        if (dt)
          this.dadosUser = dt
        else
          this.dadosUser = false
    }catch(err){
      this.dadosUser = false
    }
  }

  private extractResultsAuto(v, calc) {

    delete calc['corretora'];

    calc.isDanosMateriaisTxtRS = this.utilsService.numberFormat(calc.isDanosMateriais, true);
    calc.isDanosCorporaisTxtRS = this.utilsService.numberFormat(calc.isDanosCorporais, true);
    calc.isDanosMoraisTxtRS = this.utilsService.numberFormat(calc.isDanosMorais, true);
    calc.isAppInvalidezTxtRS = this.utilsService.numberFormat(calc.isAppInvalidez, true);
    calc.isAppMorteTxtRS = this.utilsService.numberFormat(calc.isAppMorte, true);
    calc.vidrosTxt = calc.vidros ? "Sim" : "Não";
    calc.farolRetrovisTxt = calc.farolRetrovis ? "Sim" : "Não";
    calc.isBlindagemValorTxtRS = this.utilsService.numberFormat(calc?.isBlindagemValor, true);

    if (calc.resultados && calc.resultados.length) {

      let id = 0;

      calc.resultados.map(function (vrr) {
        id = id + 1;
        vrr.ramo = this.ramo;
        vrr.idPacote = calc.seguradora + "-" + id;
        vrr.nome = this.utilsService.getSegNameById(calc.seguradora);
        vrr.logo = this.utilsService.getPathLogoById(calc.seguradora);

        vrr.idIntegracaoCfgSeg = calc.idIntegracaoCfgSeg;
        vrr.seguradora = calc.seguradora;

        vrr.tempoResposta = calc.tempoResposta / 1000;
        vrr.isError = calc.erros ? calc.erros.length > 0 : false;
        if (!vrr.isError && !vrr.premio)
          vrr.isError = true;

        vrr.isComissaoAdicional = vrr.comissaoAdicional ? true : false;
        if (vrr.isComissaoAdicional)
          vrr.comissaoAdicionalTxt = this.utilsService.numberFormat(vrr.comissaoAdicional);

        if (vrr.principal && !vrr.identificacao) {
          vrr.identificacao = "Principal";
        } else if (!vrr.principal && !vrr.identificacao) {
          vrr.identificacao = "Alternativo";
        }

        try{
          if (this.dadosUser){
            const temp = this.dadosUser.find(seg => seg.seguradora == calc.seguradora)
            console.log(temp);
            ///RECALCULO///
            if (temp?.admin )
              this.recalculoService.habilitaRecalculo(vrr, calc, v);
            else if (!temp?.admin && !temp?.configsSeg?.configsGlobais)
              this.recalculoService.habilitaRecalculo(vrr, calc, v);
            ///RECALCULO///
          }
        }catch(err){
          console.log(err);
        }

        vrr.identificacaoLim = vrr.identificacao;

        if (vrr.identificacaoLim.length >= 24) {
          vrr.identificacaoLim = vrr.identificacaoLim.replace(/(.{0,22}).*/, "$1...")
        }

        vrr.retorno = calc.retorno;

        vrr.isAjusteSeguradora = calc?.isAjusteSeguradora && vrr.principal ? true : false;
        if(vrr.isAjusteSeguradora && calc?.valoresAjusteSeguradora) vrr.valoresAjusteSeguradora = calc?.valoresAjusteSeguradora;
        this.extractInfosCartaoPorto(vrr);
        vrr.nroCalculo = vrr.nroCalculo ? vrr.nroCalculo : calc.nroCalculo;
        vrr.premioTxt = vrr.premio ? this.utilsService.numberFormat(parseFloat(vrr.premio)) : "--";
        vrr.franquiaTxt = vrr.franquia ? this.utilsService.numberFormat(parseFloat(vrr.franquia)) : "--";
        if (parseFloat(vrr.franquia) == 0)
          vrr.franquiaTxt = "--";
        vrr.premioTxtRS = vrr.premio ? this.utilsService.numberFormat(parseFloat(vrr.premio), true) : "--";
        vrr.franquiaTxtRS = vrr.franquia ? this.utilsService.numberFormat(parseFloat(vrr.franquia), true) : "--";
        if (!vrr.hasOwnProperty('coberturas')) vrr.coberturas = {};
        vrr.coberturas.cascoTxt = vrr.coberturas.casco ? (vrr.coberturas.casco + "%") : "--";
        vrr.coberturas.isDanosMateriaisTxt = vrr.coberturas.isDanosMateriais ? this.utilsService.numberFormat(vrr.coberturas.isDanosMateriais) : "--";
        vrr.coberturas.isDanosMateriaisTxtRS = vrr.coberturas.isDanosMateriais ? this.utilsService.numberFormat(vrr.coberturas.isDanosMateriais, true) : "--";
        vrr.coberturas.isDanosCorporaisTxt = vrr.coberturas.isDanosCorporais ? this.utilsService.numberFormat(vrr.coberturas.isDanosCorporais) : "--";
        vrr.coberturas.isDanosCorporaisTxtRS = vrr.coberturas.isDanosCorporais ? this.utilsService.numberFormat(vrr.coberturas.isDanosCorporais, true) : "--";
        vrr.coberturas.isDanosMoraisTxt = vrr.coberturas.isDanosMorais ? this.utilsService.numberFormat(vrr.coberturas.isDanosMorais) : "--";
        vrr.coberturas.isDanosMoraisTxtRS = vrr.coberturas.isDanosMorais ? this.utilsService.numberFormat(vrr.coberturas.isDanosMorais, true) : "--";
        vrr.coberturas.isAppInvalidezTxt = vrr.coberturas.isAppInvalidez ? this.utilsService.numberFormat(vrr.coberturas.isAppInvalidez) : "--";
        vrr.coberturas.isAppInvalidezTxtRS = vrr.coberturas.isAppInvalidez ? this.utilsService.numberFormat(vrr.coberturas.isAppInvalidez, true) : "";
        vrr.coberturas.isAppMorteTxt = vrr.coberturas.isAppMorte ? this.utilsService.numberFormat(vrr.coberturas.isAppMorte) : "--";
        vrr.coberturas.isAppMorteTxtRS = vrr.coberturas.isAppMorte ? this.utilsService.numberFormat(vrr.coberturas.isAppMorte, true) : "";
        vrr.coberturas.isBlindagemValorTxt = vrr.coberturas?.isBlindagemValor ? this.utilsService.numberFormat(vrr.coberturas?.isBlindagemValor) : "--";
        vrr.coberturas.isBlindagemValorTxtRS = vrr.coberturas?.isBlindagemValor ? this.utilsService.numberFormat(vrr.coberturas?.isBlindagemValor, true) : "";


        let isAlternative = this.utilsService.isCalcAutoAlternative(calc.seguradora);

        if (vrr.coberturas.percComissao) {
          vrr.coberturas.percComissaoTxt = vrr.coberturas.percComissao ? (vrr.coberturas.percComissao + "%") : "--";
        } else if (vrr.principal && !isAlternative) {
          vrr.coberturas.percComissaoTxt = calc.percComissao ? (calc.percComissao + "%") : "--";
        } else {
          vrr.coberturas.percComissaoTxt = "--";
        }

        if (!vrr.coberturas.percComissao)
          vrr.coberturas.percComissao = calc.percComissao;

        if (vrr.coberturas.percDesconto) {
          vrr.coberturas.percDescontoTxt = vrr.coberturas.percDesconto ? (vrr.coberturas.percDesconto + "%") : "--";
        } else if (vrr.principal && !isAlternative) {
          vrr.coberturas.percDescontoTxt = calc.percDesconto ? (calc.percDesconto + "%") : "--";
        } else {
          vrr.coberturas.percDescontoTxt = "--";
        }

        if (!vrr.coberturas.percDesconto)
          vrr.coberturas.percDesconto = calc.percDesconto;

        let limCardCob = 47;
        vrr.coberturas.carroReservaTxtLim = vrr.coberturas.carroReserva ? this.utilsService.getStrTxtLimChars(vrr.coberturas.carroReserva, limCardCob) : "";
        vrr.coberturas.assist24hsTxtLim = vrr.coberturas.assist24hs ? this.utilsService.getStrTxtLimChars(vrr.coberturas.assist24hs, limCardCob) : "";
        // Existem alguns casos que a cobertura de vidros vem como um número e não como um texto, ca Porto por exemplo, por isso essa verificação
        if (typeof vrr.coberturas.vidros === 'number') {
          vrr.coberturas.vidrosTxtLim = vrr.coberturas.vidros ? this.utilsService.numberFormat(vrr.coberturas.vidros, true) : "";
        } else {
          vrr.coberturas.vidrosTxtLim = vrr.coberturas.vidros ? this.utilsService.getStrTxtLimChars(vrr.coberturas.vidros, limCardCob) : "";
        }
        vrr.coberturas.tipoTxtLim = vrr.coberturas.tipo ? this.utilsService.getStrTxtLimChars(vrr.coberturas.tipo, limCardCob) : "";

        vrr.coberturas.tipoPadronizado = vrr.coberturas.tipoPadronizado ? vrr.coberturas.tipoPadronizado : vrr.coberturas.tipoTxtLim;
        if (!vrr.coberturas.tipoPadronizado)
          vrr.coberturas.tipoPadronizado = "--";

        vrr.coberturas.franquiaPadronizado = vrr.coberturas.franquiaPadronizado ? vrr.coberturas.franquiaPadronizado : vrr.coberturas.tipoFranquia;
        if (!vrr.coberturas.franquiaPadronizado)
          vrr.coberturas.franquiaPadronizado = "--";

        if(vrr.coberturas.franquiaPadronizadoPercentual && typeof(vrr.coberturas.franquiaPadronizadoPercentual) === 'number')
          vrr.coberturas.franquiaPadronizadoPercentualTxt =  vrr.coberturas.franquiaPadronizadoPercentual.toString() + '%';

        let coberturasToFix = ["carroReserva", "assist24hs", "tipo", "vidros"];
        coberturasToFix.forEach(function (ctf) {
          vrr.coberturas[ctf] = this.utilsService.fixString(vrr.coberturas[ctf]);
        }.bind(this));

        if (calc.erros)
          calc.erros.forEach(function (ce, idx) {
            calc.erros[idx] = this.utilsService.fixString(ce);
          }.bind(this));

        if (calc.alertas)
          calc.alertas.forEach(function (ca, idx) {
            calc.alertas[idx] = this.utilsService.fixString(ca);
          }.bind(this));
        vrr.msErros = calc.erros ? calc.erros : [];

        if(vrr.hasOwnProperty('alertas')){
          vrr.msAlertas = vrr.alertas
        }
        vrr.msAlertas ? vrr.msAlertas =  vrr.msAlertas.concat(calc.alertas) : vrr.msAlertas = calc.alertas;

        vrr.veiculo = calc.veiculo;
        vrr.fipe = calc.fipe;

        let arrToAdd = vrr.isError ? "errors" : "successes";

        if (vrr.hasOwnProperty('packageType') && Object.values(this._packageType).includes(vrr.packageType)) {
          if (vrr.packageType === this._packageType.PRINCIPAL) {
            vrr.isAlternative = !vrr?.selected;
            v.results[vrr?.selected ? 'main' : 'alternatives'][arrToAdd].push(vrr);
          } else if (vrr.packageType === this._packageType.MENSAL) {
            vrr.isPorAssinatura = true;
            v.results.porAssinatura[arrToAdd].push(vrr);
          } else {
            vrr.isAlternative = true;
            v.results.alternatives[arrToAdd].push(vrr);
          }
        } else {
          let isPorAssinatura = this.utilsService.isCalcPorAssinatura(calc.seguradora);

          if (isPorAssinatura) {
            vrr.isPorAssinatura = true;
            v.results.porAssinatura[arrToAdd].push(vrr);
          } else {
            if (vrr.principal && !isAlternative) {
              vrr.isAlternative = false;
              v.results.main[arrToAdd].push(vrr);
            } else if ((!calc.retornoErro && !vrr.isError) || isAlternative) {
              vrr.isAlternative = true;
              v.results.alternatives[arrToAdd].push(vrr);
            }
          }
        }

      }.bind(this));

    } else {

      //versão antiga

      let gerarPacote = {
        principal: true,
        identificacao: "Principal",
        nome: this.utilsService.getSegNameById(calc.seguradora),
        logo: this.utilsService.getPathLogoById(calc.seguradora),
        idPacote: calc.seguradora,
        isError: null,
        retorno: calc.retorno,
        msErros: calc.erros,
        premioTxt: calc.premio ? this.utilsService.numberFormat(parseFloat(calc.premio)) : "--",
        franquiaTxt: calc.franquia ? this.utilsService.numberFormat(parseFloat(calc.franquia)) : "",
        premioTxtRS: calc.premio ? this.utilsService.numberFormat(parseFloat(calc.premio), true) : "--",
        franquiaTxtRS: calc.franquia ? this.utilsService.numberFormat(parseFloat(calc.franquia), true) : "",
        coberturas: {
          percComissao: "--",
          percDesconto: "--"
        }
      };

      gerarPacote.isError = calc.erros ? calc.erros.length > 0 : false;
      let arrToAdd = gerarPacote.isError ? "errors" : "successes";

      let commomProperties = ['desconto', 'descontoComercial', 'premio', 'franquia', 'tempoResposta'];
      commomProperties.map(function (cpm) {
        gerarPacote[cpm] = calc[cpm];
      });

      if (calc.hasOwnProperty('packageType') && Object.values(this._packageType).includes(calc.packageType)) {
        if (calc.packageType === this._packageType.PRINCIPAL)
          v.results[calc?.selected ? 'main' : 'alternatives'][arrToAdd].push(gerarPacote);
        else if (calc.packageType === this._packageType.MENSAL)
          v.results.porAssinatura[arrToAdd].push(gerarPacote);
        else
          v.results.alternatives[arrToAdd].push(gerarPacote);
      } else {
        let isPorAssinatura = this.utilsService.isCalcPorAssinatura(calc.seguradora);

        if (isPorAssinatura) {
          v.results.porAssinatura[arrToAdd].push(gerarPacote);
        } else {
          let isAlternative = this.utilsService.isCalcAutoAlternative(calc.seguradora);
          if (gerarPacote.principal && !isAlternative)
            v.results.main[arrToAdd].push(gerarPacote);
          else if ((!calc.retornoErro && !gerarPacote.isError) || isAlternative)
            v.results.alternatives[arrToAdd].push(gerarPacote);
        }
      }
    }

  }

  public tempoHabilitacaoOptionsPelaIdade(dataNascimento, _tempoHabilitacaoTxt: any[]) {
    let dataNascimentoConvertida = this.utilsService.converteDataAmerica(dataNascimento);
    let optionsIndexMax = this.utilsService.idade(dataNascimentoConvertida) - 18;
    let options = [];

    if (dataNascimento) {

      if (this.utilsService.maiorIdade(dataNascimento)) {
        for (const key in _tempoHabilitacaoTxt) {
          if (parseInt(key) <= optionsIndexMax || key == '0') {
            options.push(_tempoHabilitacaoTxt[key]);
          }
        }
        return this.utilsService.objectToViewValue(options, true);
      }
      else {
        return [];
      }
    }
  }

  extractInfosCartaoPorto(vrr) {
    try {
      vrr.clienteJaPossuiCartaoSeg = vrr?.condicoesEspeciais?.clienteJaPossuiCartaoSeg;
      vrr.ofertaCartaoSeg = vrr?.condicoesEspeciais?.ofertaCartaoSeg ? vrr.condicoesEspeciais.ofertaCartaoSeg : false;
      vrr.percCashBack = vrr?.condicoesEspeciais?.percCashBack ? vrr?.condicoesEspeciais?.percCashBack : null;
      if (vrr?.ofertaCartaoSeg && vrr.percCashBack % 1 !== 0) {
        if (isNaN(vrr.percCashBack) || typeof vrr.percCashBack == 'object')
          vrr.ofertaCartaoSeg = false;
        else if (typeof vrr.percCashBack === 'string')
          vrr.percCashBack = parseFloat(vrr.percCashBack);
        vrr.percCashBack = vrr.percCashBack.toFixed(2);
      } else if (vrr?.ofertaCartaoSeg && vrr.percCashBack % 1 === 0) {
        if (isNaN(vrr.percCashBack) || typeof vrr.percCashBack == 'object')
          vrr.ofertaCartaoSeg = false;
        else if (typeof vrr.percCashBack === 'string')
          vrr.percCashBack = parseInt(vrr.percCashBack);
      }
      vrr.premioOferta = vrr?.condicoesEspeciais?.premio ? parseFloat(vrr.condicoesEspeciais.premio) : 0;
      vrr.premioOfertaTxt = vrr?.condicoesEspeciais?.premio ? this.utilsService.numberFormat(vrr?.condicoesEspeciais?.premio) : "";
      vrr.premioOfertaTxtRS = vrr?.condicoesEspeciais?.premio ? this.utilsService.numberFormat(vrr?.condicoesEspeciais?.premio, true) : '--';
    } catch (error) {
      vrr.ofertaCartaoSeg = false;
    }
  }

}
